<template>
    <div class="missions-section">
      <h1 class="section-title">Nos Missions</h1>
      
      <div class="missions-container">
        <div class="mission" v-for="(mission, index) in missions" :key="index">
          <div class="mission-icon">
            <i :class="mission.icon"></i>
          </div>
          <div class="mission-content">
            <h2 class="mission-title">{{ mission.title }}</h2>
            <p class="mission-description">{{ mission.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "MissionsSection",
    data() {
      return {
        missions: [
  {
    title: "Déploiement d’une solution digitale “pilotée”",
    icon: "fas fa-hand-holding-heart", // ou fas fa-user-friends
    description: "L’humain et sa satisfaction restent au cœur des préoccupations dans le déploiement de cette solution."
  },
  {
    title: "Conformité du secteur immobilier",
    icon: "fas fa-balance-scale", // ou fas fa-gavel
    description: "Mettre en conformité tout un pan du secteur de l’immobilier et des investissements bancaires."
  },
  {
    title: "Partenariats technologiques innovants",
    icon: "fas fa-rocket", // ou fas fa-microchip
    description: "S’entourer des partenaires les plus innovants en matière de technologie."
  },
  {
    title: "Efficience au travail",
    icon: "fas fa-stopwatch", // ou fas fa-tachometer-alt
    description: "Accent mis sur l’efficience au travail pour permettre à chacun d'exercer son cœur de métier sans perte de temps."
  }
]
      };
    }
  };
  </script>
   <style lang="scss">
   @import './missions.scss'
   
   </style>
 
  